import {
  commonValidationSchemas,
  createValidationSchema,
  type TSchema,
} from 'infrastructure/functions';

export const createCaseInEhrSchema = () =>
  createValidationSchema({
    subject: commonValidationSchemas.string({ required: true }),
    description: commonValidationSchemas.string({ required: true }),
  });

export type Values = TSchema<ReturnType<typeof createCaseInEhrSchema>>;
